import { bindActionCreators, ActionCreatorsMapObject, Dispatch } from "redux";
import { connect } from "react-redux";
import { MyThunkDispatch } from "./types";

type MapStateToProps = (state?: object, ownProps?: object) => object;

const emptyMapStateToProps = () => {
	return {};
};

const emptyActionCreators = {};

export default (
	actionCreators: ActionCreatorsMapObject = emptyActionCreators,
	mapStateToProps: MapStateToProps = emptyMapStateToProps,
	mergeProps: Function = undefined,
	options: object = {}
) => {
	if (actionCreators === null) {
		actionCreators = emptyActionCreators;
	}

	const mapDispatchToProps = (dispatch: MyThunkDispatch) => {
		return bindActionCreators(actionCreators, dispatch);
	};

	type StateProps = ReturnType<typeof mapStateToProps>;
	type DispatchProps = ReturnType<typeof mapDispatchToProps>;

	return connect<StateProps, DispatchProps, void>(mapStateToProps, mapDispatchToProps, mergeProps, options);
};
/*
type Props = ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps> & {
		history: History;
	};

export  connect<StateProps, DispatchProps, OwnProps>
  (mapStateToProps, mapDispatchToProps)(MyComponent)
  */
